import { createStore } from "./store";
import { InitializeOptions, StartPaymentOptions } from "./types";

import { startListener } from "./messages/listener";
import { mount } from "./mount";
import { startPayment } from "./startPayment";
import { getTranslations } from "./translations";
import { unmount } from "./unmount";

/**
 * Initialize the InPage component
 * This methods displays the payment plan and listens to messages from the payment modal
 *
 * @param options: InitializeOptions
 */
export function initialize(options: InitializeOptions) {
  const store = createStore(options.environment, options.checkoutUrl);
  store.setTranslations(getTranslations(options.locale).modal);
  const { onInPageStatusChanged, unsubscribe } = startListener(
    store.getEnvironment(),
    options.checkoutUrl
  );

  const mounted = mount(options);

  if (mounted) {
    store.setEmbeddedSelector(options.selector); // For the unmount method
  }

  return {
    startPayment: (options: StartPaymentOptions) =>
      startPayment(options, store, onInPageStatusChanged),
    unmount: () => unmount(store, unsubscribe),
  };
}
